module.exports = __webpack_public_path__ + "static/media/image117.0a770a07.png";